import React from 'react';
import {Button} from "antd";
import {DeleteOutlined, PlusOutlined} from "@ant-design/icons";

const Suvmanbalari = () => {
    return (
        <div>
            <table className="table table-bordered text-center">
                <thead className="align-middle bg-info">
                <tr>
                    <th style={{width: "50px"}}  scope="col">N</th>
                    <th scope="col">Suv manbalari</th>
                    <th scope="col">FIK</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th scope="row"><input type="checkbox"/></th>
                    <td>Suv manbalari 1</td>
                    <td>1</td>
                </tr>
                <tr>
                    <th scope="row"><input type="checkbox"/></th>
                    <td>Suv manbalari 2</td>
                    <td>2</td>
                </tr>
                <tr>
                    <th scope="row"><input type="checkbox"/></th>
                    <td>Suv manbalari 3</td>
                    <td>3</td>
                </tr>
                </tbody>
            </table>
            <div className="add-data">
                <Button className="me-2" type="primary" icon={<PlusOutlined />}>
                    Yangi suv manbasi
                </Button>
                <Button type="primary" danger icon={<DeleteOutlined />}>
                    Manbani o'chirish
                </Button>
            </div>
            <h6 className="fw-bold fst-italic mt-4">Izoh: Suv manbasini o'chirishdan oldin suv manbasiga biriktirilgan iste'molchilarni o'chirish lozim!</h6>
        </div>
    );
};

export default Suvmanbalari;